<template>
  <div>
    <v-app-bar color="#f2f2f2" flat height="40" app>



      <v-btn @click="coneyBar = !coneyBar" icon>
        <i v-if="coneyBar" class="fas fa-toggle-on green--text"></i>
        <i v-else class="fas fa-toggle-off"></i>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="signOut" 
      style="letter-spacing: 0;"
      small outlined color="grey darken-1" class="text-capitalize">
  Sign Out
</v-btn>

    </v-app-bar>

    <v-navigation-drawer app color="#f2f2f2" fixed v-model="coneyBar"
    style="border-right: none;"
    >
      <v-img src="@/assets/logo.png" width="150" style="margin: 20px auto;display: block;"></v-img>

      <v-list dense>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item 
            v-for="(item, i) in items" 
            :key="i" 
            :to="item.link" 
            :disabled="item.requiresFarm && !selectedFarm"
            router
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" style="font-size: 12px;"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    coneyBar: true,
    selectedItem: 1,
    selectedFarm: null,
    items: [
      { icon: 'mdi-view-dashboard', text: 'Dashboard', link: '/seeds-software', requiresFarm: false },
      { icon: 'mdi-seed', text: 'Seeds Drop', link: '/seeds-drop', requiresFarm: true },
      { icon: 'mdi-leaf', text: 'Plants on System', link: '/plants-on-system', requiresFarm: true },
      { icon: 'mdi-package-variant-closed', text: 'Harvest/Packaging', link: '/harvest-packaging', requiresFarm: true },
      { icon: 'mdi-door-open', text: 'Leaving the Farm', link: '/leaving-the-farm', requiresFarm: true },
      { icon: 'mdi-truck', text: 'Driver', link: '/driver', requiresFarm: true },
      { icon: 'mdi-barcode', text: 'Print Label For Box', link: '/print-label-for-box', requiresFarm: true },
    ]
  }),
  mounted() {
    this.checkSelectedFarm();
  },
  methods: {
    checkSelectedFarm() {
      const storedFarm = localStorage.getItem('selectedFarm');
      if (storedFarm) {
        this.selectedFarm = JSON.parse(storedFarm);
      } else {
        this.selectedFarm = null;
        console.log('No farm selected.');
      }
    },
    Go(e) {
      window.open(e, "_self");
    },
    ...mapActions(['signOut'])
  },
  computed: {
    ...mapState(['usuario'])
  }
}
</script>

<style scoped>
  .v-list-item--disabled {
    opacity: 0.5 !important;
  }
</style>
